import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { HighlightColor, HighlightRange } from "components/dashboard/product-template-table/utils/interfaces";
import { DweenTimeUnitEnum } from "utils/time-utils";
import { ReportOptions } from "./component-print-models";
import { DashboardComponentPropsBase } from "../components/pages/dashboard/components/interfaces";

export type DatasetDataInfo = DatasetDataInfoResponse & {
  loadedTime: Date;
};

export interface DatasetFullDefaultConfig extends DashboardComponentPropsBase<ReportOptions> {
  highlightRanges?: Array<HighlightRange>;
  config?: ComponentConfigDefault;
  datasets?: Array<DatasetDefaultConfig>;
  mode?: DatasetTableMode;
  hideHeader?: boolean;
  hideRefresh?: boolean;
}

export type DatasetTableMode = "SINGLE" | "GROUPED";

export interface TimeLoadConfig {
  alignStartTo?: DweenTimeUnitEnum;
  startOffsetUnits?: DweenTimeUnitEnum;
  startOffset?: number;
  lagUnits?: DweenTimeUnitEnum;
  lagOffset?: number;
  leadUnits?: DweenTimeUnitEnum;
  leadOffset?: number;
}

export interface ComponentConfigDefault extends TimeLoadConfig {
  alignStartTo?: DweenTimeUnitEnum;
  startOffsetUnits?: DweenTimeUnitEnum;
  startOffset?: number;
  lagUnits?: DweenTimeUnitEnum;
  lagOffset?: number;
  leadUnits?: DweenTimeUnitEnum;
  leadOffset?: number;

  stepUnits?: DweenTimeUnitEnum;
  stepSize?: number;

  startAutoRefreshFrequency?: number;

  dateFormat?: DweenTimeUnitEnum;

  sort?: "ASC" | "DESC";
  itemsPerPage?: number;
  transposed?: boolean;
  showEmpty?: boolean;
  showTotal?: boolean;
  hidePagination?: boolean;
  totalType?: "SUM" | "AVG";
  totalSize?: "PAGE" | "ALL";

  hideDateColumn?: boolean;
}

export interface DatasetDefaultConfig {
  overriddenTitle?: string;
  description?: string;
  identifier: string;
  decimalPlaces?: number;
  highlightRanges?: Array<HighlightRange>;
  defaultHighlight?: HighlightColor;
  showTotal?: boolean;
  unit?: string;
  title?: string;
  totalType?: "SUM" | "AVG";
}

export interface DatasetOverrideTitleConfig {
  overriddenTitle?: string;
  description?: string;
  title: string;
  unit?: string;
  identifier: string;
  highlightRanges?: Array<HighlightRange>;
  defaultHighlight?: HighlightColor;
}

export interface HighlightMapped {
  identifier: string;
  highlightRanges?: Array<HighlightRange>;
  defaultHighlight?: HighlightColor;
}

export interface IPair {
  key: string;
  value: any;
}

export const mapDatasetDataInfoResponseToDatasetDataInfo = (dataset: DatasetDataInfoResponse) => {
  return { ...dataset, loadedTime: new Date() } as DatasetDataInfo;
};